
























import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch,
  Mixins
} from "vue-property-decorator";
import Event_bus from "@/utils/event_bus";
import NormalNotice from "./NormalNotice.vue";
import OrderMsg from "./OrderMsg.vue";
@Component({
  components: {
    NormalNotice,
    OrderMsg
  }
})
export default class OrderCompleted extends Vue {
  @Prop()
  private data: any;

  get isFreeFollow() {
    return this.data.isFreeFollow;
  }

  get offerKind() {
    return this.data.isFreeFollow
      ? "free_follow"
      : this.data.offer_data
      ? this.data.offer_data.kind
      : this.data.receipt_data.kind;
  }

  get iconClass() {
    return this.offerKind.includes("follow")
      ? "icon-app_follower"
      : this.offerKind.includes("like")
      ? "icon-app_like"
      : this.offerKind === "comment"
      ? "icon-app_comment"
      : "icon-app_view";
  }
  get cub() {
    return !this.offerKind.includes("follow");
  }

  get text() {
    return this.offerKind === "golden_follow"
      ? "Golden Followers"
      : this.offerKind.includes("follow")
      ? "Followers"
      : this.offerKind.includes("like")
      ? "likes"
      : this.offerKind + "s";
  }

  get effect() {
    return (
      (this.data && this.data.actual_effect) ||
      (this.data.data && this.data.data.final_effect) ||
      this.data.effect ||
      5
    );
  }

  get imgSrc() {
    return (
      (this.data && this.data.image) ||
      (this.data.resource &&
        (this.data.resource.image_thumb || this.data.resource.profile_pic_url))
    );
  }

  private closeMask() {
    Event_bus.$emit("show_order_completed", {
      show: false
    });
  }

  private clickClose() {
    this.closeMask();
  }
}
